import { ProjectFilters } from "../../apiclients/bstinsights";

export enum ViewType {
  MyProjects = "My Projects",
  ProjectsWithOverrides = "My Projects with Overrides",
  ProjectsWithPredictions = "My Projects with Predictions",
}

export type FilterItemType = {
  id: number;
  name: string;
  icon: string;
  displayName: string;
  showRange: boolean;
  showSearch: boolean;
};

export type UserPreferences = {
  preferenceName: string;
  value: string;
};

export type StringFilterType = Omit<
  Required<ProjectFilters>,
  "summaryProjectPredictedNLM" | "summaryPredictedMonetaryGainLoss"
>;

export type RangeFilterType = Pick<
  Required<ProjectFilters>,
  "summaryProjectPredictedNLM" | "summaryPredictedMonetaryGainLoss"
>;

type RangeFilter = {
  min?: string | null;
  max?: string | null;
};

export type ProjectFiltersWithStringRange = {
  summaryProjectPredictedNLM?: RangeFilter;
  summaryPredictedMonetaryGainLoss?: RangeFilter;
} & Omit<
  ProjectFilters,
  "summaryProjectPredictedNLM" | "summaryPredictedMonetaryGainLoss"
>;

export type ProjectStore = {
  // Filters and preferences
  view: ViewType;
  sortBy: string;
  filters: ProjectFiltersWithStringRange | undefined;
  searchText: string;
  hasOverrides?: boolean;
  hasPredictions?: boolean;

  // Data
  projectIds: number[];
  filterValues: {
    [key in keyof StringFilterType]: string[];
  };

  // Misc
  filterItems: FilterItemType[];
  noProjectMessage: string;
  visualLimitedView: boolean;
  powerBIFilterLimitError: boolean;

  // Actions
  setSortBy: (value: string) => void;
  resetFilters: () => void;
  setSearchText: (value: string) => void;
  getRangeValue: (name: string, subKey: "min" | "max") => string | undefined;
  changeRangeFilterValue: (
    name: string,
    value: string | undefined | null,
    subKey: "min" | "max"
  ) => void;
  applyFilters(): void;
  setSelectedView: (value: ViewType) => void;
  hasActiveFilter: () => boolean;
  toggleFilterValue: (name: string, value: string) => void;
  getNonEmptyFilters: () => ProjectFilters | undefined;
  setNoProjectMessage: (value: string) => void;
  getFilterValueCheckedState: (name: string, value: string) => boolean;

  // Fetch Actions
  fetchProjectIds: () => Promise<void>;
  fetchFilterItems: () => Promise<void>;
  fetchFilterValues: () => Promise<void>;
  fetchSortPreference: () => Promise<void>;
  fetchViewPreference: () => Promise<void>;

  // Save actions
  saveSortPreference: (value: string) => Promise<void>;
  saveViewPreference: (value: string) => Promise<void>;

  // PBI actions
  setVisualSort: () => Promise<void>;
  setPBIProjectFilter: () => Promise<void>;
  setVisualLimitedView: () => Promise<void>;
};
